import React from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { SourceIcon as Icon, getSourceIconDataForKey } from 'component-library-and-tools';

import { SourceProps } from './types';
import { getSourceMapper } from 'services/source/getters';
import { getThemeMode } from 'services/user/getters';
import { Theme } from 'lib/prisma-styles';

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledIcon = styled(Icon) <{ hasLabel: boolean }>`
  && {
    font-size: 1.75rem;
    width: 1.75rem;
    height: 1.75rem;

    ${({ hasLabel }) => hasLabel && css`
      margin-right: 0.416666667rem;
    `}
  }
`;

const StyledLabel = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Source = ({
  source,
  withLabel = true,
  className,
  iconClassName,
  labelClassName,
}: SourceProps) => {
  const theme: keyof Theme = useSelector(getThemeMode);

  /* Lookup flow as of this writing is heavy on fallbacks, we look for the source key
  to get a source icon by checking if server provided IDs map to a source key, otherwise
   we look up the icon by the sources name */

  const sourceIdsToKey = useSelector(getSourceMapper);
  const sourceName = source.name;

  const sourceLookupKey = sourceIdsToKey[source.id] || sourceName;
  
  const { name, ...iconAndColorProps } = getSourceIconDataForKey(sourceLookupKey);

  return (
    <StyledContainer className={className}>
      <StyledIcon
        {...iconAndColorProps}
        className={iconClassName}
        hasLabel={withLabel}
        iconUrl={source.iconUrl}
      />

      {withLabel && (
        <StyledLabel className={labelClassName} title={sourceName}>
          {sourceName}
        </StyledLabel>
      )}
    </StyledContainer>
  );
};

export default Source;